import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
import FComponentsLib from '@freelog/components-lib';
import FModal from '@/components/FModal';
import FCoverImage from '@/components/FCoverImage';
import { FI18n, FUtil } from '@freelog/tools-lib';
import { Pagination } from 'antd';

export interface OccupiedResourceItem {
  resourceID: string;
  resourceName: string;
  resourceType: string[];
  resourceVersion: string;
  url: string;
  cover: string;
  username: string;
  userAvatar: string;
}

interface FOccupiedFileResourceVersionProps {
  list: OccupiedResourceItem[];
  canOk: boolean;
}

export function fOccupiedFileResourceVersion({ list, canOk }: FOccupiedFileResourceVersionProps): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(<M
      list={list}
      canOk={canOk}
      onOk={() => {
        resolve(true);
      }}
      onCancel={() => {
        resolve(false);
      }}
      afterClose={() => {
        setTimeout(() => {
          root.unmount();
          div.remove();
        }, 100);
      }}
    />);
  });

}

export default fOccupiedFileResourceVersion;

interface MProps extends FOccupiedFileResourceVersionProps {
  onOk(): void;

  onCancel(): void;

  afterClose(): void;
}

const PAGE_SIZE = 3;

function M({ list, canOk, onOk, onCancel, afterClose }: MProps) {
  const [$open, set$open] = FUtil.Hook.useGetState<boolean>(true);
  const [$page, set$page] = React.useState<number>(1);

  const isSingle: boolean = list.length <= 1;
  const pagedList: OccupiedResourceItem[] = isSingle
    ? list
    : list.slice(($page - 1) * PAGE_SIZE, $page * PAGE_SIZE);

  return (<FModal
    title={null}
    width={900}
    open={$open}
    onCancel={() => {
      onCancel();
      set$open(false);
    }}
    footer={null}
    afterClose={afterClose}
  >
    <div className={styles.container}>
      <div className={styles.title}>
        {
          canOk
            // 您曾经发行过该文件/对象
            ? FI18n.i18nNext.tAuto('submitresource_err_resourceexist_sameuser')
            // 该文件/对象已被其它用户发行
            : FI18n.i18nNext.tAuto('submitresource_err_resourceexist_otheruser')
        }
      </div>

      <div className={styles.content}>
        <div className={styles.cards}>
          {pagedList.map((item) => (<Card key={item.url} item={item} />))}
        </div>

        {!isSingle && (
          <div className={styles.pagination}>
            <Pagination
              size='small'
              current={$page}
              pageSize={PAGE_SIZE}
              total={list.length}
              showSizeChanger={false}
              showTotal={(total) => `共 ${total} 条`}
              onChange={(page) => set$page(page)}
            />
          </div>
        )}
      </div>

      <div className={styles.footer}>
        {canOk ? (
          <>
            <FComponentsLib.FRectBtn
              type='default'
              onClick={() => {
                onCancel();
                set$open(false);
              }}
            >
              {
                // 取消
                FI18n.i18nNext.tAuto('btn_cancel')
              }
            </FComponentsLib.FRectBtn>
            <FComponentsLib.FRectBtn
              type='primary'
              onClick={() => {
                onOk();
                set$open(false);
              }}
            >继续上传</FComponentsLib.FRectBtn>
          </>
        ) : (
          <FComponentsLib.FRectBtn
            type='primary'
            onClick={() => {
              onCancel();
              set$open(false);
            }}
          >知道了</FComponentsLib.FRectBtn>
        )}
      </div>
    </div>
  </FModal>);
}

function Card({ item }: { item: OccupiedResourceItem }) {
  return (<div
    className={styles.card}
    onClick={() => {
      window.open(item.url);
    }}
  >
    <FCoverImage src={item.cover} width={220} style={{ borderRadius: 6 }} />
    <div className={styles.info}>
      <FComponentsLib.FContentText
        type='highlight'
        text={item.resourceName}
        singleRow
        style={{ maxWidth: 220 }}
      />
      <FComponentsLib.FContentText
        type='additional2'
        text={item.resourceType.join(' / ')}
        singleRow
        style={{ maxWidth: 220 }}
      />
      <FComponentsLib.FContentText
        type='additional2'
        text={`版本 ${item.resourceVersion}`}
        singleRow
        style={{ maxWidth: 220 }}
      />
    </div>
    <div className={styles.user}>
      <img src={item.userAvatar} alt='' />
      <span>{item.username}</span>
    </div>
  </div>);
}
